import { atom, useAtom } from "jotai";

import { Status } from "../../types/app/messages";
import { WorkerAPI } from "../../types/app/worker";

export const useWorkerAtom = atom<{ api: WorkerAPI } | null>(null);
export const useStatusAtom = atom<Status>(Status.Offline);

export const useWorker = () => {
  const [worker, setWorker] = useAtom(useWorkerAtom);
  const [status, setStatus] = useAtom(useStatusAtom);

  const isWorkerReady = worker !== null && status === Status.Ready;
  const workerApi = isWorkerReady ? worker.api : null;

  return {
    worker: workerApi,
    status,
    isWorkerReady,
    setWorker,
    setStatus,
  };
};
